module.exports = __webpack_public_path__ + "static/img/56970_0_dziecko z psem gory_original115.f905c27d.png";